export type Contact = {
    name: string;
    email: string;
};

export type JobApplicationInput = {
    contact: Contact;
    msg: string;
    errand?: string;
    cvList?: File[];
};

const baseUrl = 'https://anchoredit-communication-service.orangedune-23d9740d.swedencentral.azurecontainerapps.io';
const endpoint = `${baseUrl}/job-applications`;

export async function submitJobApplication({
                                               contact,
                                               msg,
                                               errand,
                                               cvList = [],
                                           }: JobApplicationInput): Promise<Response> {

    const formData = new FormData();

    const application = {
        contact,
        msg,
        errand,
    };

    formData.append(
        'application',
        new Blob(
            [JSON.stringify(application)],
            { type: 'application/json' }
        )
    );

    cvList.forEach((file) => {
        formData.append('cvList', file);
    });

    const response = await fetch(endpoint, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        throw new Error(`Failed to send application: ${response.status}`);
    }
    return  response;
}